import React from "react";
import { useIntl } from "react-intl";
import { useNavigate } from "react-router";
import { Link } from "@mui/material";
import { makeStyles } from "tss-react/mui";
import { constructLinkWithId } from "./utils.js";
const useStyles = makeStyles()((theme) => ({
  link: {
    color: theme.palette.primary.main,
    cursor: "pointer"
  }
}));
function withLink(WrappedComponent, underlineAlways) {
  return function LinkHOC({ ...props }) {
    const { classes } = useStyles();
    const { title, onClick, className, underline, href, target = "_self" } = props;
    const { formatMessage } = useIntl();
    const formattedTitle = title ? typeof title === "string" ? title : formatMessage(title) : "";
    return /* @__PURE__ */ React.createElement(
      Link,
      {
        underline: underline ?? (underlineAlways ? "always" : "none"),
        href,
        target,
        className: `${classes.link} ${className}`,
        onClick,
        "data-testid": "linkAction",
        title: formattedTitle
      },
      /* @__PURE__ */ React.createElement(WrappedComponent, { ...props })
    );
  };
}
function withRouterLink(WrappedComponent, idQueryFilterKey) {
  return function RouterLinkHOC({ ...props }) {
    const navigate = useNavigate();
    const { path, id } = props;
    const fullUrl = constructLinkWithId({ path, id, idQueryFilterKey });
    const handleNavigation = () => {
      navigate(fullUrl);
    };
    return /* @__PURE__ */ React.createElement(WrappedComponent, { ...props, onClick: handleNavigation });
  };
}
export {
  withLink,
  withRouterLink
};
//# sourceMappingURL=LinkHOC.js.map
